import { useTranslation } from 'react-i18next';

/**
 * Explains why student/parent WhatsApp preference toggles are disabled.
 * Backend sets licenseWhatsAppEnabled (ChessDesk license) and
 * academyWhatsAppEnabled (admin master switch + WATI setup).
 */
export function getWhatsAppUnavailableMessage(prefs, { forParent = false, t } = {}) {
    if (!prefs || !t) return null;
    if (prefs.licenseWhatsAppEnabled && prefs.academyWhatsAppEnabled) return null;

    const phoneHint = forParent
        ? t('settings.whatsapp.unavailable.phoneHintParent')
        : t('settings.whatsapp.unavailable.phoneHintStudent');

    if (!prefs.licenseWhatsAppEnabled) {
        return {
            title: t('settings.whatsapp.unavailable.notAvailableTitle'),
            body: t('settings.whatsapp.unavailable.notAvailableBody', { phoneHint }),
        };
    }

    return {
        title: t('settings.whatsapp.unavailable.notSetupTitle'),
        body: t('settings.whatsapp.unavailable.notSetupBody', { phoneHint }),
    };
}

export default function WhatsAppUnavailableNotice({ prefs, forParent = false }) {
    const { t } = useTranslation();
    const message = getWhatsAppUnavailableMessage(prefs, { forParent, t });
    if (!message) return null;

    return (
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            <p className="font-semibold">{message.title}</p>
            <p className="mt-1 leading-relaxed">{message.body}</p>
        </div>
    );
}
